export default {
    header: {
        telefone: "Teléfono",
        signIn: "Iniciar sesión",
        register: "Registrarse",
        becomeExpert: "Registra tu empresa",
        dashboard: "Panel",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Reserva de Tuk Tuk",
                menu: {
                    grid: "Listado de Tuk Tuk",
                },
            },
            about: {
                title: "Acerca de",
                subtitle: "Acerca de",
                menu: {
                    aboutUs: "Sobre nosotros",
                    testimonials: "Testimonios",
                    faq: "Preguntas frecuentes",
                    contact: "Contáctanos",
                    terms: "Términos y condiciones",
                    privacy: "Política de privacidad",
                },
            },
            dashboard: {
                title: "Panel",
                subtitle: "Panel del usuario",
                subtitle2: "Panel del agente",
                menu: {
                    dashboard: "Panel",
                    myBookings: "Mis reservas",
                    reviews: "Reseñas",
                    support: "Soporte",
                    wishlist: "Lista de deseos",
                    wallet: "Billetera",
                    profileSettings: "Configuración de perfil",
                    notifications: "Notificaciones",
                    myProfile: "Mi perfil",
                    settings: "Configuración",
                    dashboard2: "Panel",
                    bookings: "Reservas",
                    enquiries: "Consultas",
                    earnings: "Ganancias",
                    reviews2: "Reseñas",
                    settings2: "Configuración",
                },
            },
            social: {
                title: "Red Social",
                subtitle: "Feed de Publicaciones",
                menu: {
                    feed: "Feed",
                    myProfilePage: "Mi página de perfil",
                    explore: "Explorar",
                },
            },
        },
    },

    common: {
        welcome: "¡Bienvenido, {{name}}!",
    },

    home: {
        hero: {
            title: "Acércate al sueño:",
            title2: "lo esencial de tu viaje te espera",
            title3: "a ti",
            subtitle: "Tu destino definitivo para todo lo que ayuda a celebrar y recordar tu experiencia de viaje.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Paquetes",
            titleSuffix: "recientes",
            subtitle:
                "Descubre los paquetes más recientes añadidos a Portugalwaytour y explora oportunidades de viaje únicas cuidadosamente seleccionadas para brindarte experiencias inolvidables, nuevos destinos y aventuras exclusivas en todo el mundo.",
            noPackages: "No se encontraron paquetes recientes.",
            hasDiferencial: "Tiene diferencial",
            noReviews: "Sin reseñas",
            viewAll: "Ver todos los paquetes",
        },
        sectionBenefit: {
            titlePrefix: "Nuestros",
            titleHighlight: "Beneficios",
            titleSuffix: "y principales ventajas",
            subtitle:
                "Portugalway, un operador turístico especializado en destinos de ensueño, ofrece una variedad de beneficios para los viajeros.",
            benefits: [
                {
                    title: "Experiencias Auténticas",
                    description:
                        "¡Escapa del turismo tradicional y descubre el Portugal auténtico! Nuestros tours ofrecen experiencias genuinas explorando la cultura local, la gastronomía y lugares secretos.",
                },
                {
                    title: "Paquetes de Viajes Personalizados",
                    description:
                        "¡Crea tu viaje a medida! Elige tu experiencia y nosotros nos encargamos de todo: alojamiento, transporte y actividades, para un viaje personalizado e inolvidable.",
                },
                {
                    title: "Confort y Seguridad",
                    description:
                        "Cuidamos todos los detalles: transporte cómodo, alojamiento seleccionado y acompañamiento de guías profesionales, garantizando tranquilidad de principio a fin del viaje.",
                },
                {
                    title: "Atención Dedicada",
                    description:
                        "Desde el primer contacto hasta el regreso de tu viaje, cuentas con soporte personalizado y un equipo listo para atender en portugués e inglés, con agilidad y atención total a tus necesidades.",
                },
            ],
        },
        exploreCities: {
            title: "Explorar por Ciudad",
            subtitle: "Descubre experiencias únicas en destinos increíbles",
        },
        placeSection: {
            titlePrefix: "Paquetes",
            titleHighlight: "en tendencia",
            subtitle:
                "Explora nuestros paquetes de viaje más populares, cuidadosamente seleccionados por sus altas calificaciones, reseñas positivas y reservas frecuentes de otros viajeros. Encuentra tu próxima aventura inolvidable aquí.",
            all: "Todos",
            hasDiferencial: "Tiene diferencial",
            noReviews: "Sin reseñas",
            viewAll: "Ver todos los paquetes",
        },
        aboutSection: {
            welcome: "Bienvenido a Portugalwaytour",
            title: "Explora más allá del horizonte: descubre las maravillas del mundo",
            description1: "En Portugal Way Tour, creemos que viajar es transformar. Somos una agencia especializada en experiencias turísticas únicas en Portugal, comprometida en revelar lo mejor del país — su cultura, paisajes, historia y autenticidad.",
            point1: "Proporcionar viajes memorables, con confort, seguridad y encanto. Queremos que cada turista descubra Portugal de forma profunda, con itinerarios que mezclan tradición, naturaleza, gastronomía y hospitalidad genuina.",
            point2: "Ser referencia de calidad y confianza en el turismo en Portugal, reconocida por turistas de todo el mundo como sinónimo de profesionalismo y encanto.",
            learnMore: "Saber más",
            reviews: "{{count}}+ Reseñas"
        },
        aboutCounters: [
            { label: "Destinos en el mundo", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Reservas completadas", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clientes globalmente", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Proveedores registrados", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Populares",
            popularSubtitle: "Descubre los servicios más populares, mejor valorados y frecuentemente reservados por los viajeros.",
            serviceName: "Conductor de Tuk Tuk",
            loading: "Cargando...",
            reservationsSingular: "reserva",
            reservationsPlural: "reservas",
            viewProfile: "Ver Perfil",
            viewAll: "Ver Todos",
        },
        driverModal: {
            loading: "Cargando...",
            description: "Descripción",
            languages: "Idiomas",
            vehicle: "Vehículo",
            seats: "asientos",
            averageRating: "Valoración Media",
            reviews: "Reseñas",
            packages: "Paquetes",
            noReviews: "Sin reseñas aún",
            noPackages: "Este conductor no tiene paquetes registrados"
        },
        testimonialSection: {
            title: "Lo que dicen nuestros {{highlight}}",
            highlight: "usuarios",
            subtitle: "Descubre lo que nuestros viajeros pensaron de sus experiencias.",
            loading: "Cargando reseñas...",
            noReviews: "No se encontraron reseñas.",
            noComment: "El usuario no dejó comentario.",
            viewPackage: "Ver detalles del paquete"
        },
        updateSection: {
            faq: {
                title: "Preguntas {{highlight}}",
                highlight: "Frecuentes",
                subtitle: "Portugalway, un operador turístico especializado en destinos de ensueño, ofrece una variedad de beneficios para los viajeros.",
                questions: [
                    {
                        question: "¿Cómo hago para reservar un tour?",
                        answer: "Puedes reservar directamente a través de nuestra página web o contactarnos por correo electrónico o teléfono. Después de definir el itinerario deseado, te enviaremos un presupuesto, confirmaremos hoteles y servicios, y solicitaremos el pago según la política informada."
                    },
                    {
                        question: "¿Es posible personalizar el itinerario?",
                        answer: "¡Sí! Todos nuestros itinerarios son flexibles. Tú eliges los lugares que quieres visitar, la duración, el tipo de alojamiento y, dentro de las posibilidades, creamos algo que combine con tu perfil."
                    },
                    {
                        question: "¿Cuáles son los idiomas de los guías?",
                        answer: "Tenemos guías que hablan portugués, inglés y, dependiendo del tour, otros idiomas. Informa tus preferencias al reservar para que podamos asignar el guía más adecuado."
                    },
                    {
                        question: "¿Cómo es la política de cancelación?",
                        answer: "Tenemos una política de cancelación que varía según el tour, la antelación y los proveedores. En el momento de la reserva, te enviaremos los términos completos. Te pedimos que los leas con atención antes de confirmar."
                    },
                    {
                        question: "¿Cuáles son las formas de pago aceptadas?",
                        answer: "Aceptamos transferencia bancaria internacional, tarjeta de crédito y, en algunos casos, otros métodos de pago."
                    }
                ],
                contactUsText: "Si no encuentras la respuesta a tu pregunta en nuestras Preguntas Frecuentes, contáctanos. ¡Te responderemos pronto!",
                contactButton: "Contáctanos",
            },
            support: {
                items: [
                    "Itinerarios Personalizados",
                    "Planificación Completa",
                    "Orientación de Expertos",
                    "Experiencia Local",
                    "Soporte al Cliente",
                    "Esfuerzos de Sostenibilidad",
                    "Múltiples Regiones"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Páginas",
            settings: "Configuración",
            profile: "Perfil",
            social: "Red Social",
        },
        company: {
            title: "Empresa",
            about: "Sobre Nosotros",
            testimonials: "Testimonios",
            faq: "Preguntas Frecuentes",
        },
        support: {
            title: "Soporte",
            contact: "Contáctanos",
            privacy: "Política de Privacidad",
            terms: "Términos y Condiciones",
            chat: "Atención por Chat",
        },
        services: {
            title: "Servicios",
            tuktuk: "Tuk Tuk",
            winery: "Bodega",
            restaurant: "Restaurante",
            car: "Coche",
            hippotrip: "Hippotrip",
            bike: "Bicicleta",
        },
        bottom: {
            copyright: "Copyright © 2025. Todos los derechos reservados,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Accede a tu cuenta",
            subtitle: "Ingresa tu correo electrónico para iniciar sesión o crear una cuenta",
            emailLabel: "Correo electrónico",
            emailPlaceholder: "Ingresa tu correo electrónico",
            sendTestCode: "Enviar código de prueba",
            sendEmailCode: "Enviar código por correo electrónico",
            codeLabel: "Código de verificación",
            codePlaceholder: "Ingresa el código",
            verifyAndLogin: "Verificar e Iniciar Sesión",
            testCodeSuccess: "Código de prueba '123456' generado. Úsalo para iniciar sesión.",
            testCodeError: "Error al generar código de prueba.",
            emailSent: "¡Código enviado a tu correo electrónico!",
            emailError: "Error al enviar código por correo electrónico.",
            loginSuccess: "¡Inicio de sesión realizado con éxito!",
            invalidCode: "Código inválido o expirado.",
            or: "O",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Completa tu perfil",
            reminderText: "¡No olvides completar tu perfil para aprovechar todas las funciones de la plataforma!",
            gotIt: "Entendido",
        },
    },
    companyRegisterModal: {
        title: "Registro de Empresa",
        step1: "Por favor, introduce tu correo electrónico personal para crear una cuenta de administrador de la empresa. Utilizarás esta cuenta para gestionar el perfil de la empresa.",
        step2: "Hemos enviado un código de verificación a tu correo electrónico. Introdúcelo a continuación para verificar tu identidad.",
        step3: "Ahora, completa los datos de tu empresa. El correo electrónico de la empresa debe ser un contacto corporativo (ej.: info@empresa.com).",

        personalEmail: "Tu correo electrónico personal",
        sendTestCode: "Enviar código de prueba",
        sendEmailCode: "Enviar código por email",

        verificationCode: "Código de verificación",
        verifyCode: "Verificar código",

        companyEmail: "Correo electrónico de la empresa",
        companyName: "Nombre de la empresa",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "Número del certificado permanente",
        phone: "Teléfono",
        street: "Calle",
        city: "Ciudad",
        postalCode: "Código postal",
        country: "País",
        companyDescription: "Breve descripción de la empresa",
        servicesProvided: "Servicios ofrecidos",

        contractTitle: "Contrato de la Empresa",
        acceptContract: "Acepto el contrato de la empresa",
        finishRegistration: "Finalizar registro",

        messages: {
            "Test code sent successfully. Use '123456'.": "Código de prueba enviado con éxito. Usa '123456'.",
            "Verification email sent successfully.": "Código enviado por email con éxito.",
            "Verification successful.": "Verificación realizada con éxito.",
            "Company registered and contract accepted successfully!": "¡Empresa registrada y contrato aceptado con éxito!",
            testStepMessage: "Código de prueba enviado con éxito. Usa '123456'.",
            emailStepMessage: "Se ha enviado un código de verificación a tu correo electrónico. Introdúcelo a continuación."
        },

        errors: {
            "Failed to send the verification code.": "Error al enviar el código de verificación.",
            "Invalid or expired code.": "Código inválido o expirado.",
            "Please fill all required fields.": "Por favor, rellena todos los campos obligatorios.",
            "You must accept the contract to register the company.": "Debes aceptar el contrato para registrar la empresa.",
            "You must be logged in to register the company.": "Debes iniciar sesión para registrar la empresa.",
            "Failed to register the company or accept the contract.": "Error al registrar la empresa o aceptar el contrato."
        }
    },
    chooseUsSection: {
        title: "¿Por qué elegirnos?",
        cards: [
            {
                title: "Conveniencia",
                description: "Planifica todo tu viaje desde una única plataforma, ahorrando tiempo y esfuerzo. Ya no tendrás que alternar entre diferentes sitios web."
            },
            {
                title: "Garantía del mejor precio",
                description: "Trabajamos con socios de viaje confiables para ofrecerte las mejores ofertas, ya sea al reservar un vuelo, hotel o alquiler de coche."
            },
            {
                title: "Soporte al cliente",
                description: "Nuestro equipo de soporte dedicado está a tu disposición 24 horas al día, 7 días a la semana, garantizando que tus planes de viaje se desarrollen sin problemas de principio a fin."
            },
            {
                title: "Experiencias de viaje personalizadas",
                description: "Ya sea que viajes por negocios, unas vacaciones familiares o una aventura en solitario, ofrecemos opciones que se adaptan a todas las necesidades."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Inicio",
            pages: "Páginas",
            contactUs: "Contacto"
        },
        title: "Ponte en contacto con nuestro equipo de soporte dedicado",
        description: "Nuestro equipo está listo para ayudarte. Tu satisfacción es nuestra prioridad.",
        info: [
            {
                label: "Dirección de correo electrónico",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Número de teléfono",
                value: "INSERT NUMBER"
            },
            {
                label: "Nuestra ubicación",
                value: "INSERT RUA , Almada - Portugal"
            }
        ],
        supportCard: {
            title: "¿Necesitas soporte?",
            textLoggedOut: "Para contactar a nuestro equipo de soporte y abrir tickets, necesitas crear una cuenta o iniciar sesión. Después de eso, tendrás acceso completo a tu panel de soporte, donde podrás seguir y gestionar tus solicitudes.",
            textLoggedIn: "¡Ya has iniciado sesión! Ahora puedes abrir un nuevo ticket de soporte o seguir los tickets existentes directamente en tu panel.",
            btnLoggedOut: "Crear Cuenta / Iniciar Sesión",
            btnLoggedIn: "Abrir Ticket en el Panel"
        }
    },

    sidebar: {
        main: "Principal",
        dashboard: "Panel",
        myBookings: "Mis Reservas",
        myReviews: "Reseñas",
        wishlist: "Lista de Deseos",
        support: "Soporte",
        finance: "Financiero",
        wallet: "Billetera",
        payments: "Pagos",
        account: "Cuenta",
        myProfile: "Mi Perfil",
        notifications: "Notificaciones",
        settings: "Configuración",
        preferences: "Preferencias",
        logout: "Cerrar sesión",
    },

    agentSidebar: {
        dashboard: "Panel",
        bookings: "Reservas",
        tukTukBookings: "Reservas de Tuk Tuk",
        hotelBookings: "Reservas de Hotel",
        carBookings: "Reservas de Coche",
        cruiseBookings: "Reservas de Crucero",
        tourBookings: "Reservas de Tour",
        flightBookings: "Reservas de Vuelos",
        enquiries: "Consultas",
        earnings: "Ganancias",
        reviews: "Reseñas",
        support: "Soporte",
        serviceEnrollment: "Registro de Servicios",
        drivers: "Conductores",
        tukTukVehicles: "Vehículos de Tuk Tuk",
        settings: "Configuración",
        logout: "Cerrar sesión",
    },

    dashboardCards: {
        totalBookings: "Total de Paquetes Comprados",
        totalListings: "Total de Paquetes",
        totalEarnings: "Total de Ganancias",
        totalReviews: "Total de Reseñas",
    },

    recentlyadded: {
        titulo: "Añadido recientemente",
    },

    BookingsStatistics: {
        titulo: "Estadísticas de reservas",
        loading: "Cargando estadísticas...",
        none: "Ninguna reserva registrada aún.",
    }
};